import { MarketingNav } from '@/components/layout/marketing-nav'
import { SiteFooter } from '@/components/layout/site-footer'
import { NoIndexMeta } from '@/components/seo/no-index-meta'
import { PageMeta } from '@/components/seo/page-meta'
import { Button } from '@/components/ui/button'
import { PELGO_NOT_FOUND_SEO } from '@/lib/pelgo-seo'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex flex-col min-h-screen bg-card">
      <PageMeta config={PELGO_NOT_FOUND_SEO} />
      <NoIndexMeta />
      <MarketingNav variant="standalone" />

      <main className="flex-1 flex items-center justify-center px-4 pt-32 pb-16">
        <div className="max-w-lg text-center space-y-6">
          <p className="text-sm font-semibold uppercase tracking-wide text-pelgo-blue-light">404</p>
          <h1 className="text-4xl md:text-5xl font-display text-foreground tracking-[-0.96px]">
            Page not found
          </h1>
          <p className="text-base font-medium text-muted-foreground tracking-[-0.32px] leading-relaxed">
            The page you are looking for does not exist or may have moved. Try one of the links
            below.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
            <Button asChild className="rounded-full">
              <Link to="/">Back to Home</Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/contact">Contact Us</Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full">
              <Link to="/resources/whitepapers">Whitepapers</Link>
            </Button>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}
